import { InjectionToken } from "@angular/core";

export const MODAL_DATA = new InjectionToken<Record<string, unknown>>('MODAL_DATA');